// AI Generated Test
import { Component, OnInit, Input } from '@angular/core';
import { AccessibilityLineChartServiceFactory } from '@client/app/blocks/service/charts/accessibility-line-chart/accessibility-line-chart.service';
import { DateTimeService } from '@client/app/services/date-time/date-time.service';

@Component({
    selector: 'accessibility-summary-line-chart',
    standalone: false,
    template: `
        <mon-chart-line *ngIf="chartLoaded"
                    [options]="options"
                    [height]="'250'"
                    [labels]="labels"
                    [data]="data"
                    [series]="series"
                    [colors]="colors"
                    [override]="overrides">
        </mon-chart-line>
    `,
})
export class AccessibilitySummaryLineChartComponent implements OnInit {
    @Input() history: any;
    @Input() data: any;
    @Input() options: any;

    chartLoaded: boolean = false;
    colors: any;
    labels: any;
    overrides: any;
    series: any;

    constructor (
        private accessibilityLineChartServiceFactory: AccessibilityLineChartServiceFactory,
        private dateTimeService: DateTimeService,
    ) {}

    ngOnInit (): void {
        this.setupLineChart();
    }

    private setupLineChart (): void {
        const service = this.accessibilityLineChartServiceFactory.createInstance();
        service.init();
        service.setup().then(() => {
            this.colors = service.getColors();
            this.labels = this.setupLabels();
            this.overrides = service.getOverride();
            this.series = service.getSeries();
            this.chartLoaded = true;
        }, () => {});
    }

    private setupLabels (): any {
        const labels = this.history.map((crawl: any) => {
            return new Date(crawl.date);
        });
        if (labels.length > 0) {
            labels.unshift(this.dateTimeService.substractDuration(labels[0], 2, 'days'));
            labels.push(this.dateTimeService.addDuration(labels[labels.length - 1], 2, 'days'));
        }

        return labels;
    }
}
